import { fetchQuery, graphql } from "relay-runtime"
import {
  deTranslateQuery as deTranslateQueryType,
  TranslateInput,
} from "@/modules/chats/services/ai/de/__generated__/deTranslateQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query deTranslateQuery($input: TranslateInput!) {
    translate: de_translate(input: $input) {
      ...TextResultFragment @relay(mask: false)
    }
  }
`

export const deTranslateQuery = (input: TranslateInput) => {
  return fetchQuery<deTranslateQueryType>(RelayEnvironment, query, { input }).toPromise()
}
